import { gql } from "@apollo/client";

export const GET_BRAND = gql(`
  query brand($id: String!) {
    brand(id: $id) {
      id
      name
      logo
      description
      rating
      categories
      productsCount
      completedCollabs
      inviteCode
      status
      createdAt
      updatedAt
    }
  }
`);

export const GET_BRAND_WITH_REVIEWS = gql(`
  query brandWithReviews($id: String!) {
    brand(id: $id) {
      id
      name
      logo
      description
      rating
      categories
      productsCount
      completedCollabs
      inviteCode
      status
      createdAt
      updatedAt
      reviews {
        id
        rating
        comment
        createdAt
        reviewerType
        reviewerId
        revieweeId
        reviewer {
          ... on User {
            name
            imageUrl
          }
          ... on Brand {
            brandName: name
            logo
          }
        }
      }
    }
  }
`);

export const GET_ALL_BRANDS = gql(`
  query brands {
    brands {
      id
      name
      logo
      description
      rating
      categories
      productsCount
      completedCollabs
      inviteCode
      status
      createdAt
      updatedAt
    }
  }
`);

export const CHECK_BRAND_INVITE_CODE = gql(`
  query checkBrandInviteCode($code: String!) {
    checkBrandInviteCode(code: $code)
  }
`);
